import {
  useAddActivity,
  useDealActivities,
  useDeleteActivity,
  usePinDealActivity,
  useUpdateActivity,
} from '@/features/activity/useActivities'
import ActivityLog from '@/components/ActivityLog'

/**
 * The deal's activity timeline (log a note/call + filterable feed), wired to the deal hooks.
 * With {@code compact} it renders a minimal read-only Overview preview: the newest {@code limit}
 * entries as an icon + snippet list (no composer/filters); the "View all" link lives in the card header.
 */
export default function DealActivity({
  dealId,
  limit,
  compact,
  hideComposer,
  onOpenTask,
}: {
  dealId: string
  limit?: number
  compact?: boolean
  hideComposer?: boolean
  /** Reveal the task a "Task created/completed" entry is about, in the deal's Tasks card. */
  onOpenTask?: (taskId: string) => void
}) {
  const { data: activities } = useDealActivities(dealId)
  const add = useAddActivity(dealId)
  const update = useUpdateActivity(dealId)
  const remove = useDeleteActivity(dealId)
  const pin = usePinDealActivity(dealId)

  return (
    <ActivityLog
      activities={activities}
      add={add}
      update={update}
      remove={remove}
      pin={pin}
      limit={limit}
      compact={compact}
      hideComposer={hideComposer}
      onOpenTask={onOpenTask}
    />
  )
}
